import { Contract } from "@/services/backend/vbs/contracts/types/contract";
import t from "@/lang/lang";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import {
  CommonDialogFooter,
  CommonDialogHeader,
} from "@/shared/components/dialog/dialog-common";
import { useVbsContractCopyFromOfferMutation } from "@/services/backend/vbs/contracts/api/contract-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { toast } from "sonner";
import { Copy } from "lucide-react";

export function CopyFromOfferDialog({
  contract,
  offerId,
}: {
  contract: Contract;
  offerId: string;
}) {
  const [open, setOpen] = useState(false);
  const [patch, { isLoading, error, isSuccess, reset }] =
    useVbsContractCopyFromOfferMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
      toast.success(t("Daten aus Angebot übernommen"));
    }
  }, [isSuccess, reset]);

  const doDelete = () => {
    if (isLoading) return;

    patch({ id: contract.id, offerId });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">
          <Copy className="size-4" />
          <span>{t("Angebot kopieren")}</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <CommonDialogHeader
          title={t("Daten aus Angebot kopieren")}
          description={t(
            "Die aktuellen Daten werden gelöscht und durch die Daten aus dem Angebot ersetzt.",
          )}
        />
        <RTKQueryErrorAlert error={error} onDismiss={reset} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doDelete} />
      </DialogContent>
    </Dialog>
  );
}
